module.exports = __webpack_public_path__ + "8760b925f534806e310378af1221d607.png";